import React from 'react';

export default function CoachPage({ showChecklist = false, children }) {
    return <>{children}</>;
}
